import {MflError, MflUserEntityErrorCode} from '../models/mfl';

import {capitalizeFirstLetter} from './string';

const apiFieldNameToFriendlyName = (apiFieldName = '') =>
  capitalizeFirstLetter(apiFieldName.replace('_', ' '));

const extractFieldNameFromSourcePointer = (
  prefix: string,
  sourcePointer = '',
) =>
  sourcePointer
    .substring(prefix.length)
    .split('/')
    .map(apiFieldNameToFriendlyName)
    .join('/');

/**
 * MFL entity: user_identity. Source locators examples:
 * - /user_identity/first_name -> First name
 * - /user_identity/last_name -> Last name
 * - /user_identity/password -> Password
 * - /user_identity/billing_address/lines -> Billing address lines
 * - /user_identity/billing_address/locality -> Billing address locality
 * - /user_identity/birth_date -> Birth date
 */
function getErrorMessage(prefix: string, error: MflError) {
  const defaultErrorMessage = 'Unable to create user.';

  const detail = error.detail ? capitalizeFirstLetter(error.detail) : '';
  const sourcePointer = error.source?.pointer;
  const fieldName = extractFieldNameFromSourcePointer(prefix, sourcePointer);
  const errorMessage =
    fieldName && detail ? `${fieldName}: ${detail}` : defaultErrorMessage;

  return errorMessage;
}

const getCreateOrUpdateUserErrorMessage = (error: MflError) =>
  getErrorMessage('/user_identity/', error);

export const getCreateOrUpdateUserErrorMessages = (errors: MflError[] = []) =>
  errors.map(getCreateOrUpdateUserErrorMessage).join('.');

export const isUnhandledMFL500Error = (error: string = '') =>
  error.includes('something went wrong (500)');

export const hasWeakPasswordError = (errors: MflError[] = []) =>
  errors.some(
    e =>
      e.code === MflUserEntityErrorCode.sign_up_form_password_too_weak ||
      e.code === MflUserEntityErrorCode.password_too_weak,
  );

export const getApiErrorMessage = (error: any) =>
  error?.response?.data?.errors?.[0]?.detail || error.message;
